// Ported from CarbonEngine (MIT, (c) 2026 CCP Games) - https://github.com/carbonengine/trinity
//   audio/src/AudSettings.h
// Generated by format-carbon carbon-class --emit. Verify against audio/AudSettings.json.
import { io, type } from "@carbonenginejs/runtime-utils/schema";
import { CjsModel } from "@carbonenginejs/runtime-utils/model";

/** AudSettings (audio) - generated from schema shapeHash 9f163503.... */
@type.define({ className: "AudSettings", family: "audio" })
export class AudSettings extends CjsModel
{

  /** m_baseSoundBankPath (std::string) [READWRITE] */
  @io.readwrite
  @type.string
  baseSoundbankPath = "res:/Audio";

  /** m_soundbankLanguage (std::string) [READWRITE] */
  @io.readwrite
  @type.string
  soundbankLanguage = "en";

  /** m_spatialAudioDeviceName (std::string) [READWRITE] */
  @io.readwrite
  @type.string
  spatialAudioDeviceName = "System";

  /** m_stereoAudioDeviceName (std::string) [READWRITE] */
  @io.readwrite
  @type.string
  stereoAudioDeviceName = "System_Stereo";

  /** m_applicationName (std::string) [READWRITE] */
  @io.readwrite
  @type.string
  applicationName = "Eve Online";

  /** m_essentialPath (std::string) [READWRITE] */
  @io.readwrite
  @type.string
  essentialPath = "Essential_Media";

  /** m_spatialAudioEnabled (bool) [READWRITE] */
  @io.readwrite
  @type.boolean
  spatialAudioEnabled = true;

}
